const ViewManager = require('civicsUtils/view_manager');

define(function (require) {
	return Marionette.ItemView.extend({

		config:{},
		tagName: function () {
			if (this.options && this.options.isGrid) {
				return 'td';
			}
			return 'div';
		},
		S4:function() {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		},
		generateId:function() {
			return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
		},
		//Marionette Functions Start
		initialize:function(options){
			if(options.config){
				this.config = options.config;
			}

			if (this.childInitialize != null) {
				this.childInitialize(options);
			}
			this.name = this.model.get('bind') ? this.model.get('bind') : this.model.get('id');
			this.processCustomAttr();
		},
		processCustomAttr:function(){//the child elements add to the custom attributes, so lets make sure we have a trailing space, or an empty string
			let customAttr = this.model.get('customAttr');
			if(customAttr){
				customAttr = customAttr.trim()+' ';
			} else {
				customAttr = '';
			}
			customAttr+='data-originalValue="'+this.model.get('value')+'"';
			this.model.set({customAttr:customAttr},{silent:true});

		},
		className:function(){
			if(this.model.get('isVisible')===false){
				return 'field-container hidden';
			} else if (this.options && this.options.isGrid) {
				return 'grid-data';
			}
			if (this.model.get('fieldContainerClass')) {
				return 'field-container ' + this.model.get('fieldContainerClass');
			}
			return 'field-container';
		},
		onRender:function(){
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			this.displayErrors();
		},
		displayErrors:function(){
			if(this.model.get('errorMessage')){
				let error = {validationError:{}};
				error.validationError[this.name] = this.model.get('errorMessage');
				ViewManager.errorToWindow(error,this);
			}
		},
		templateHelpers:function(){
			return {
				disabled:this.model.get('isEnabled') === false,
				id:this.model.get('id') ? this.model.get('id') : this.generateId(),
				name:this.name,
				readOnlyForm:this.config.readOnlyForm || this.model.get('displayOnly')===true,
				tooltip: this.model.get('description'),
				//javascript treats 0 like a false, causing it to not be added to an input. the server normally returns "0", but we need to catcht he times it sends 0.
				value: () => {
					var val = this.model.get('value');
					if (val === 0) {
						val = val.toString();
					}
					return val;
				}
			};
		},
		//Marionette Functions End
		/*the bind can contain a period, which indicates a nested object structure. we want to avoid
		data:{
			color.color:red
		}
		and instead end up with
		data:{
			color:{
				color:red
			}
		}
		There are only two scenarios that this should occur: code definitions and foreign key relationships.
		for more information, look at HPS-120526, where a field with a foreign key relation to another table was 
		causing problems because the bind was "color.color"

		Note that theoretically there may be multiple layers of nesting, so we won't restrict this.
		*/
		getData: function () {
			var data = {};
			var val = this.getValue();
			if (val != null) {
				//lo dash set() takes in the object to be modified, a dot delimited path, and a value, then either updates the value if it exists, 
				//or creates the object path and sets the value.
				_.set(data,this.name, val);
			}
			
			return data;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			var val = this.$el.find('input').val();
			if (val != null && (val == "" || val.trim().length == 0)) {
				val = null;
			}
			return val;
		},
		//get the minimum for the field, based on the field dataType and the custom minimum provided
		getMinValue(dataType,rangeMinValid){
			let dataTypeMinimum = null;
			if(dataType){
				switch (dataType.toLowerCase()) {
					case 'system.int16':
						dataTypeMinimum = -32768;//minimum value of Int16
						break;
					case 'system.int32':
						dataTypeMinimum = -2147483648;//minimum  value of Int32
						break;
					case 'system.int64':
						dataTypeMinimum = -9223372036854775808;//minimum  value of Int64
						break;
					default://null
						break;
				}
				//WE CURRENTLY ONLY SUPPORT A MINIMUM OF 0 OR HIGHER
				dataTypeMinimum = dataTypeMinimum == null ? null : 0;
				//WE CURRENTLY ONLY SUPPORT A MINIMUM OF 0 OR HIGHER
				//comment out the above line to use the actual minimums for the data type.
				//for more information, see the inlineValidations/formatNumber.js file in the civics theme.

				//if there's no custom minimum range, return the data type range(this might be null)
				if(rangeMinValid == null){
					return dataTypeMinimum;
				} else if(dataTypeMinimum!=null){//otherwise if dataTypeMinimum is also not null, return the max of the two numbers.
					return Math.max(dataTypeMinimum,rangeMinValid);
				}	
			}
			return rangeMinValid;//otherwise, return the custom minimum range
		},
		//get the maximum for the field, based on the field dataType and the custom maximum provided
		getMaxValue(dataType,rangeMaxValid){
			let dataTypeMaximum = null;
			if(dataType){
				switch (dataType.toLowerCase()) {
					case 'system.int16':
						dataTypeMaximum = 32767;//maximum value of Int16
						break;
					case 'system.int32':
						dataTypeMaximum = 2147483647;//maximum value of int32
						break;
					case 'system.int64':
						dataTypeMaximum = 9223372036854775807;//maximum value of int64
						break;
					default://null	
						break;
				}
				//we have a minimum of 0 on our number fields so if we have a max of 0, the field is unusable. ignore maxes of 0.
				if(rangeMaxValid == null|| rangeMaxValid == 0){//if we don't have a custom max range, return the data type max. this might be null.
					return dataTypeMaximum;
				} else if(dataTypeMaximum!=null){//otherwise if the dataType max is also not null, return the minimum of them.
					return Math.min(dataTypeMaximum,rangeMaxValid);
				}
				
			}
			return rangeMinValid;//otherwise, just return the custom max.
		}
	});
});
